import { edgeDebug } from '@/shared/debug';

/**
 * Converts a CPX timestamp to the required format for both UA headers and event data
 * @param timestamp - The raw timestamp from CPX event
 * @returns Object containing both the header string and event data number value in seconds
 */
export function convertCpxTimestamp(timestamp?: number | string): {
  eventTimestamp?: number;
  headerTimestamp: string;
} {
  edgeDebug.debug('Converting CPX timestamp:', timestamp);

  if (!timestamp) {
    edgeDebug.warn('No timestamp provided to convertCpxTimestamp');
    return { headerTimestamp: '' };
  }

  const timestampStr = String(timestamp);

  // Try parsing as ISO date first
  const date = new Date(timestampStr);
  if (!Number.isNaN(date.getTime())) {
    const result = {
      eventTimestamp: Math.floor(date.getTime() / 1000), // Convert to seconds
      headerTimestamp: timestampStr,
    };
    edgeDebug.debug('Converted ISO timestamp:', result);
    return result;
  }

  // If not ISO, try as numeric timestamp
  const timestampNum = Number(timestamp);
  if (Number.isNaN(timestampNum)) {
    edgeDebug.error('Invalid timestamp format:', timestamp);
    return { headerTimestamp: '' };
  }

  // If the timestamp is already in seconds (typically less than 13 digits),
  // use it as is, otherwise convert from milliseconds
  // const isMilliseconds = String(timestampNum).length > 12;
  // const result = {
  //   eventTimestamp: isMilliseconds
  //     ? Math.floor(timestampNum / 1000)
  //     : timestampNum,
  //   headerTimestamp: timestampStr,
  // };

  //
  // edgeDebug.debug('Converted numeric timestamp:', result);
  return {
    eventTimestamp: timestampNum,
    headerTimestamp: timestampStr,
  };
}
